import { render, staticRenderFns } from "./Ziel.vue?vue&type=template&id=4b327cbe&scoped=true"
import script from "./Ziel.vue?vue&type=script&lang=js"
export * from "./Ziel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b327cbe",
  null
  
)

export default component.exports